// client/src/ownerListingRoutes.js — routes for owner self-service listings, in one file
// (App.js spreads these, the same way as wave2Routes.js).
import React from 'react';
import { Route } from 'react-router-dom';
import OwnerSignupPage from './pages/ownerListings/OwnerSignupPage';
import OwnerVerifyEmailPage from './pages/ownerListings/OwnerVerifyEmailPage';
import OwnerListingsPage from './pages/ownerListings/OwnerListingsPage';
import OwnerListingEditPage from './pages/ownerListings/OwnerListingEditPage';
import ListingMessagesPage from './pages/ownerListings/ListingMessagesPage';
import ListingSubmissionsPage from './pages/secure/ListingSubmissionsPage';

/** Inside the client portal layout (/client-portal, portal login). */
export const ownerPortalRoutes = () => [
    <Route key="ol-list" path="my-listings" element={<OwnerListingsPage />} />,
    <Route key="ol-edit" path="my-listings/:id" element={<OwnerListingEditPage />} />,
];

/** Stand-alone pages (no portal frame). */
export const ownerStandaloneRoutes = () => [
    <Route key="ol-signup" path="/list-your-property" element={<OwnerSignupPage />} />,
    <Route key="ol-verify" path="/client-portal/verify-email" element={<OwnerVerifyEmailPage />} />,
    <Route key="ol-msgs" path="/listing-messages/:token" element={<ListingMessagesPage />} />,
];

/** Under /dashboard (staff login). */
export const ownerDashboardRoutes = () => [
    <Route key="ol-subs" path="listing-submissions" element={<ListingSubmissionsPage />} />,
];
